/**
 * Class that represents the API status
 */
export class ApiStatus {
    error: boolean = false;
    code: string = '';
    type: string = '';
    message: string = '';
}